<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

    Table wrapper

------------------------------->
<sb-table-wrapper-new
  headline="{{'lang.globals.userMembership' | translate}}"
  [itemsData]="users"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'users'">

  <!------------------------------

    Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

      <sb-filter-section
        title="{{'lang.globals.filterAttributes' |translate}}" icon="toggleOn"
        classes="tw-flex tw-flex-col tw-gap-2">
        <sb-filter-threeway-toggle filterID="blocked" [default]="null"
                                   [label]="'lang.globals.blocked' | translate"></sb-filter-threeway-toggle>
      </sb-filter-section>

      <sb-filter-section title="{{'lang.globals.client' | translate}}"
                         icon="company">
        <sb-filter-dto-list-select filterID="clients" [endpoint]="api._admin_Client_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>

      <sb-filter-section title="{{'lang.globals.roles' | translate}}"
                         icon="user">
        <sb-filter-dto-list-select filterID="roles" [endpoint]="api._admin_Role_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>

    </sb-filter-panel>
  </div>

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.userName' | translate }}
      </th>
      <th>
        {{ 'lang.globals.lastName' | translate }}
      </th>
      <th>
        {{ 'lang.globals.firstName' | translate }}
      </th>
      <th>
        {{ 'lang.globals.email' | translate }}
      </th>
      <th>
        {{ 'lang.globals.client' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

     Table Body

------------------------------->
  <ng-template #tbody let-user>
    <tr>
      <td>
        {{ user?.user?.id }}
      </td>
      <td>
        {{ user?.user?.username }}
      </td>
      <td>
        {{ user?.user?.lastname }}
      </td>
      <td>
        {{ user?.user?.firstname }}
      </td>
      <td>
        {{ user?.user?.email }}
      </td>
      <td>
        {{ user?.client?.id }}
      </td>
    </tr>
  </ng-template>
  <!------------------------------

    Card Element

------------------------------->
  <!-- No card element -->

</sb-table-wrapper-new>
